<template>
  <div @keyup.13="submit">
    <mu-dialog
      title="新增订单"
      width="500"
      :open="open"
      @close="close"
      class="create-dialog"
    >
      <mu-form :model="form" label-position="left" label-width="100" ref="form">
        <mu-form-item prop="orderId" label="订单号">
          <mu-text-field v-model="form.orderId"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="customer" label="客户">
          <mu-text-field v-model="form.customer"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="clerk" label="业务员">
          <mu-text-field v-model="form.clerk"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="sum" label="总金额">
          <mu-text-field v-model="form.sum"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="paid" label="已付金额">
          <mu-text-field v-model="form.paid"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="cadFile" label="CAD文件路径">
          <mu-text-field v-model="form.cadFile"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="cadFileName" label="CAD文件名">
          <mu-text-field v-model="form.cadFileName"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="remark" label="备注">
          <mu-text-field v-model="form.remark"></mu-text-field>
        </mu-form-item>
      </mu-form>
      <mu-button slot="actions" flat color="secondary" @click="close"
        >取消</mu-button
      >
      <mu-button slot="actions" color="primary" @click="submit">提交</mu-button>
    </mu-dialog>
  </div>
</template>

<script>
import backend from 'utils/backend'
import api from '@/api'
export default {
  props: {
    open: {
      tpye: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        orderId: '',
        customer: '',
        clerk: '',
        sum: '',
        paid: '',
        cadFile: '',
        cadFileName: '',
        remark: ''
      }
    }
  },
  methods: {
    submit() {
      this.$refs.form.validate().then((flag) => {
        if (flag) {
          backend(api.order.create, this.form).then((result) => {
            if (result.statusCode === 200) {
              this.close()
              this.$emit('finish')
              this.form = {
                orderId: '',
                customer: '',
                clerk: '',
                sum: '',
                paid: '',
                cadFile: '',
                cadFileName: '',
                remark: ''
              }
            }
          })
        }
      })
    },
    close() {
      this.$emit('update:open', false)
    }
  }
}
</script>

<style lang="less" scoped>
.create-dialog {
}
</style>



// WEBPACK FOOTER //
// src/views/order/create.vue